module.exports = __webpack_public_path__ + "img/3-1.57f82996.svg";